import React from 'react'
import { css } from '@emotion/core'
import { i18n } from '@fs/zion-locale'

const koreanCss = css`
  /* Don't break words for Korean */
  * {
    word-break: keep-all !important;
  }
`

export default function GlobalAppStyles({ children }) {
  if (i18n.language === 'ko')
    return (
      <div css={koreanCss} data-testid="korean-styles-applied">
        {children}
      </div>
    )
  return children
}
